import React, { Fragment, useContext, useState } from "react";

import "./Header.scss";

import { Button, UnlockWallet } from "../";

import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core";
import { UserContext } from "../../store/context/UserContex";
import { useUpdateEffect } from "../../hooks";
import { switchNetwork } from "../../utils/connector";
import { Link } from "react-router-dom";
import AccountModal from "../Modals/AccountModal";
import logo from '../../assets/logo/Picture1.webp';


const Header: React.FC = () => {
  const [dropdown, setDropdown] = useState(false);
  const { account, error } = useWeb3React();
  const {
    userData: { tokenBalance },
  } = useContext(UserContext);

  useUpdateEffect(() => {
    if (error && error instanceof UnsupportedChainIdError) switchNetwork();
  }, [error]);

  return (
    <Fragment>
      <header className="header pad">
        <div className="logo">
          <img src={logo} alt="logo" />
          
        </div>
        <div className="nav_links">
          <Link to="/">Home</Link>
          <Link to="/farms">Farms</Link>
          <Link to="/swap">Swap</Link>
          
          <Link to="/Liquidity">Liquidity</Link>
          
        </div>
        <div className="block_right">
          {account ? (
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
            <Button onClick={() => setDropdown(true)} style={{marginRight:'2em'}}>Get Referral Link</Button>
            <Button variant="secondary" >
              <span className="pr-5 ">
                {`${account.slice(0, 6)}...${account.slice(
                  account.length - 6
                )}`}{" "}
              </span>
              <strong className=" pl-5">
                {new Intl.NumberFormat("en-US", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 4,
                }).format(tokenBalance)}
                &nbsp; CHX
              </strong>
            </Button>
            </div>
          ) : (
            <UnlockWallet />
          )}
        </div>
      </header>
      <AccountModal modal={dropdown} handleClose={() => setDropdown(false)} />
    </Fragment>
  );
};

export default Header;
